import * as React from "react";
// Remember that all const are suffix _svg

const plus_svg = (
  <svg
    className={"accordion-icon icon_svg"}
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="55"
    viewBox="0 0 54 55"
    fill="none"
  >
    <circle cx="27.0467" cy="27.9897" r="25.3868" fill="#B0173C" stroke="white" strokeWidth="2.20754" />
    <path
      d="M20.424 27.9897H33.6693"
      stroke="white"
      strokeWidth="3.31132"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.0467 21.3671L27.0467 34.6124"
      stroke="white"
      strokeWidth="3.31132"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { plus_svg };
